import App from "./components/App";
import { AppContainer } from "react-hot-loader";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import { ThemeProvider } from "@fluentui/react";
import React from "react";
import * as ReactDOM from "react-dom";
import "./index.css";
import { Provider } from "react-redux";
import store from "../state/store";
import ModalBanner from "./components/modal/ModalBanner";
import ErrorBoundary from "./ErrorBoundary";
import QueryProvider from "./QueryProvider";
import { getExcelVersion, Host, IExcelVersion } from "../util/versioning";

/* global document, Office, module, require */

initializeIcons();

let isOfficeInitialized = false;

const title = "MFA Addin";

const getVersionString = (v: IExcelVersion): string => `${v.majorVersion}.${v.minorVersion}.${v.build}.${v.revision}`;

const v = getExcelVersion();

console.log(v);

if (v) {
  let log = `[MFA] Running inside ${v?.host}`;

  if (v?.host !== Host.Browser) log += `, version '${getVersionString(v)}'`;
  if (v?.isLocalhost) log += ', local development deployment';

  console.log(log);
}

const render = (Component: any) => {
  ReactDOM.render(
    <AppContainer>
      <Provider store={store}>
        {/* inside the Provider: the fallback page reads redux state, so it must not render outside it */}
        <ErrorBoundary>
          <QueryProvider>
            <ThemeProvider theme={{ palette: { themePrimary: "#24A6BB" } }} className="vw-100 vh-100 d-flex flex-column">
              <div className="app d-flex flex-column vh-100 vw-100">
                <ModalBanner />
                <Component title={title} isOfficeInitialized={isOfficeInitialized} />
              </div>
            </ThemeProvider>
          </QueryProvider>
        </ErrorBoundary>
      </Provider>
    </AppContainer>,
    document.getElementById("container")
  );
};

/* Render application after Office initializes */
Office.onReady(() => {
  isOfficeInitialized = true;
  render(App);
});


if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    render(NextApp);
  });
}
